import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a small cafe table: a round 0.7 oak top at 0.75 on a
// matte-black pedestal column with a round floor base.
const TOP = "#c8975a";
const PEDESTAL = "#2e2e30";

export const cafeTable = defineModel({
  id: "cafe-table",
  batchId: "modern",
  name: "Cafe table",
  tags: ["modern", "interior", "furniture", "restaurant", "table", "cafe"],
  summary: "A small round cafe table on a black pedestal.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // round floor base
      { geometry: new THREE.CylinderGeometry(0.22, 0.24, 0.04, 16), color: PEDESTAL, position: [0, 0.02, 0] },
      // pedestal column
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.67, 10), color: PEDESTAL, position: [0, 0.375, 0] },
      // round table top (top surface at 0.75)
      { geometry: new THREE.CylinderGeometry(0.35, 0.35, 0.04, 20), color: TOP, position: [0, 0.73, 0] },
    ];
  },
  animations: [],
});
